export default `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
    <path d="M360.040 1024l-208.080-207.217 304.783-304.783-304.783-304.783 208.080-207.217 493.869 493.004 18.132 18.995-0.863 0.863v0.863z"></path>
</svg>
`;
